<template>
  <div class="cloud-error-container">
    <div class="ibf-h1-larger login-title">
      {{ $t('login.licenseError.title') }}
    </div>
    <div class="login-subtitle ib-color-text-grey .ibf-amount2">
      {{ $t('login.licenseError.subtitle') }}
    </div>
    <div>
      <img
        src="@/assets/images/error.png"
        class="error-icon"
        alt="Cloud Status Error"
      />
    </div>
    <div id="support-link">
      <a :href="supportMailUrl">{{ $t('login.licenseError.supportLink') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloudError',
  data() {
    return {
      supportMailUrl: process.env.VUE_APP_SUPPORT_MAIL,
    };
  },
};
</script>

<style lang="scss" scoped>
.cloud-error-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 300px;
  height: 400px;
  margin: 0 auto;
  #support-link {
    text-align: center;
    font-size: 11px;

    & a {
      color: #1b1b1b;
    }
  }
}
.login-subtitle {
  margin-top: 37px;
}
</style>
